<mat-chip-grid>
   @for (item of value; track trackBy(item)) {
   <mat-chip-option [value]="item" removable>
      {{ item.name }}
      <mat-icon matChipRemove>cancel</mat-icon>
   </mat-chip-option>
   }
   <ng-content></ng-content>
</mat-chip-grid>
